import React, { useEffect, useState } from 'react';
import { withRouter } from "react-router-dom";
import { useHistory } from 'react-router';
import "./Sports.css";
import { config, PERMISSIONS } from "../../../../../config";
import axiosApi from '../../../../../core/interceptor/interceptor';
import add from "../../../../../assets/add-icon.svg";
import { permissions } from '../../../../../Store/reducers/PermissionsReducer.js';
import { useSelector } from 'react-redux';

function Sports() {
    const permission = useSelector(permissions);
    const history = useHistory();
    const [listData, setListData] = useState([]);
    const [addEditPermission, setAddEditPermission] = useState(false);
    const [loading, setLoading] = useState(true);
    const getSports = () => {
        setLoading(true);
        axiosApi.get(`${config.apiUrl}/sports`)
            .then((response) => {
                setTimeout(() => {
                    let list = [];
                    for (var i = 0; i < response.data.total; i++) {
                        let imgSrc = `${config.cdnUrl}/sports/${response.data.data[i]['image']}`;
                        let editPath = `/admin/leagues/sports/edit-sports/${response.data.data[i]['id']}`
                        list.push(<div className="inner-blk" onClick={() => addEditPermission && history.push(editPath)} key={`${'sport-list-' + (i + 1)}`}>
                            <div className="img-blk">
                                <img src={imgSrc} alt={response.data.data[i]['image']}/>
                            </div>
                            <div className="heading-blk">
                                <span title={response.data.data[i]['title']} className="black-text">{response.data.data[i]['title']}</span>
                            </div>
                        </div>)
                    }
                    setListData(list);
                    setTimeout(() => setLoading(false), 100);
                }, 100);

            })
            .catch((err) => {
                setLoading(false);
            });
    }

    useEffect(() => {
        setAddEditPermission(Array.isArray(permission) && permission.includes(PERMISSIONS.LEAGUE_MODIFICATIONS))
        getSports();
        //eslint-disable-next-line
    },[permission, addEditPermission])


    return <>
        <div className="content-wrapper leagues-wrapper">
            <div className="inner-wrapper">
                <div className="heading-wrapper relative">
                    <div className="left">
                        <h1 className="heading">Sports</h1>
                        {addEditPermission && <p>Select a sport to modify rules, image and settings</p>}
                    </div>
                    {
                        addEditPermission &&
                        <div className="right">
                            <button className='header-btn abs' onClick={() => history.push('/admin/leagues/sports/edit-sports')}><img src={add} alt="" />Add Sport</button>
                        </div>
                    }
                </div>
            </div>
            {
                listData &&
                    listData.length > 0 ?
                    <div className="games-wrapper cs-resp">
                        {listData}
                    </div>
                    :
                    (!loading && <div className="noRecord-found-classifieds">No record found</div>)

            }
        </div>
    </>
}

export default withRouter(Sports);